import React from "react";
import { Box } from "@mui/system";
import { styles } from "./styles";
import { useSelector, useDispatch } from "react-redux";
import {
  allFilters,
  filterHeaderSearchFollowers,
} from "../../redux/actions/filterActions";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { filterSelectedIndexes, getUniqueListBy } from "../../utils/helpers";
import Checkbox from "../Buttons/Checkbox/Checkbox";

const NumberOfFollowersFilter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // followers slice from redux
  const followersHeaderSelector = useSelector(
    (state) => state?.filterHeaderFollowers?.payload
  );
  const allFiltersSelector = useSelector((state) => state?.allFilters?.payload);

  console.log(
    "followersHeaderSelector",
    followersHeaderSelector,
    allFiltersSelector
  );

  const handleChange = (item) => {
    item.isChecked = !item.isChecked;

    const result = getUniqueListBy([...followersHeaderSelector, item], "index");
    dispatch(filterHeaderSearchFollowers(result));

    const new_followers_number = filterSelectedIndexes(result, "index");
    const payload = [...new Set(new_followers_number)];

    const queryPayload = { follower_number: payload };
    console.log("payload123", queryPayload, result, item);
    dispatch(allFilters(queryPayload));

    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...allFiltersSelector,
        follower_number: payload,
      }).toString(),
    });
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.filterContainer}>
        {followersHeaderSelector?.map((item) => (
          <Box key={item.type} sx={styles.flex}>
            <Checkbox
              onClick={() => handleChange(item)}
              checked={item.isChecked}
              label={item.type}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NumberOfFollowersFilter;
